"use client";
import { useState } from "react";
import { formatContentWithLinks } from "@/lib/stringUtil";
import { faMinus, faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export interface FaqProps  {
    header: string;
    content: string;
    priority: number; // Optional priority field
};

const ListSection: React.FC<{ list: FaqProps[] }> = ({ list }) => {
    const [expandedIndices, setExpandedIndices] = useState<number[]>([]);

    const toggleContent = (index: number) => {
        if (expandedIndices.includes(index)) {
            setExpandedIndices(expandedIndices.filter((i) => i !== index));
        } else {
            setExpandedIndices([...expandedIndices, index]);
        }
    };

    return list.map((item, index, array) => {
        const isExpanded = expandedIndices.includes(index);
        const isLastItem = index === array.length - 1;

        return (
            <div key={index} className={isLastItem ? "" : "mb-3"}>
                <button
                    className="flex items-start cursor-pointer w-full text-left"
                    onClick={() => toggleContent(index)}
                >
                    <FontAwesomeIcon
                        icon={isExpanded ? faMinus : faPlus}
                        className="text-[#196ecf] hover:underline font-extrabold inline-flex items-center w-2.75 h-2.75 transition-transform duration-400 mt-1"
                        style={{ marginRight: '0.25rem' }}
                    />
                    <span className="text-[16px] !font-semibold text-[#196ecf] hover:underline">
                        {`${index+1}. ${item.header}`}
                    </span>
                </button>
                <div
                    className={`text-gray-700 pl-6 overflow-hidden transition-all duration-500 ease-in-out ${
                        isExpanded ? "max-h-screen opacity-100 mt-2" : "max-h-0 opacity-0"
                    } faq-content`}
                    dangerouslySetInnerHTML={{ __html: formatContentWithLinks(item.content) }}
                />
            </div>
        );
    });
};

export default ListSection;